/**
 * Manufacturing API
 * Manufacturing API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Stub, 1 = SignalR, 2 = Mqtt
 */
export enum StationConnectionKind {
    Stub = 0,
    SignalR = 1,
    Mqtt = 2
}

